'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$17() {
  this.b5W = null;
  this.b5X = false;
}
export { $c_Lpresto_LoginPageView$$anon$17 as $c_Lpresto_LoginPageView$$anon$17 };
$p = $c_Lpresto_LoginPageView$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$17;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$17() {
}
export { $h_Lpresto_LoginPageView$$anon$17 as $h_Lpresto_LoginPageView$$anon$17 };
$h_Lpresto_LoginPageView$$anon$17.prototype = $p;
$p.P = (function() {
  if ((!this.b5X)) {
    this.b5W = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T4($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aA()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aA()));
    this.b5X = true;
  }
  return this.b5W;
});
var $d_Lpresto_LoginPageView$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$17, "presto.LoginPageView$$anon$17", ({
  M8: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$17 as $d_Lpresto_LoginPageView$$anon$17 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$17.js.map
